import { head } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { ConsiderationContent } from '../../../../../src/client/types/__codegen__/sanity/graphql';
import { GET_CONSIDERATION_CONTENT } from '../../../../../src/client/pages/consideration-landing/queries/get-consideration-content/query.gql';
import uniqueContentWithDraftPrecedence from '../../../../../src/client/cms/utils/unique-content-with-draft-precedence';

type UseGetConsiderationContent = {
  skip?: boolean;
  slug: string;
};

const useGetConsiderationContent = ({ skip = false, slug }: UseGetConsiderationContent) => {
  const { data, loading, error } = useQuery(GET_CONSIDERATION_CONTENT, {
    skip,
    variables: { slug },
  });

  return {
    considerationContent: head(uniqueContentWithDraftPrecedence(data?.allConsiderationContent)) as ConsiderationContent,
    error,
    hasErrors: Boolean(error),
    isLoading: skip || loading,
  };
};

export default useGetConsiderationContent;
